import { useQuery } from '@tanstack/react-query';

import type { CombinedVacancyType } from 'clients/ReachoutClient/ReachoutClient.types';

import { Vacancy } from 'clients/AutoCompleteClient/types';
import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';
import { QueryKey } from 'types/query';
import { getVacancyName } from 'utils/vacancyEnrichedUtils';

export const useEnrichedVacanciesQuery = ({
  search = '',
  enabled,
  indeedOnly = false,
  atsOnly = false,
}: { search?: string; enabled?: boolean; indeedOnly?: boolean; atsOnly?: boolean } = {}) => {
  return useQuery<Vacancy[]>(
    [QueryKey.useEnrichedVacanciesQuery, { search: search || '', indeedOnly, atsOnly }],
    async () => fetchEnrichedVacancies(search, indeedOnly, atsOnly),
    {
      keepPreviousData: true,
      cacheTime: 5 * 60 * 1000,
      staleTime: 5 * 60 * 1000,
      initialData: [],
      initialDataUpdatedAt: 0,
      enabled,
      retry: false,
    },
  );
};

export const fetchEnrichedVacancies = async (search?: string, indeedOnly?: boolean, atsOnly?: boolean) => {
  let vacancyTypes: CombinedVacancyType[];

  if (indeedOnly) {
    vacancyTypes = ['INDEED'];
  } else if (atsOnly) {
    vacancyTypes = ['ATS', 'ATS_RAW'];
  } else {
    vacancyTypes = ['ATS', 'ATS_RAW', 'CREATED', 'CAMPAIGN'];
  }

  const { data } = await reachoutClient.listCombinedVacancies(search, vacancyTypes);

  return data.map((vacancy) => ({
    name: getVacancyName(vacancy),
    value: vacancy.job_ats_id ?? vacancy.job_indeed_id,
    ...vacancy,
  })) as Vacancy[];
};
